import React from 'react';
export const CURSOR_SWITCH_THRESHOLD = 50;
const MIN_CURSOR_SIZE = 5;
export function BrushCursor({
  size,
  fillColor
}: {
  size: number;
  fillColor?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <circle cx={size / 2} cy={size / 2} r={size / 2} fill={fillColor || 'currentColor'} />
    </svg>;
}
export function BrushCursorIcon(size: number) {
  // if size is too small, use MIN_CURSOR_SIZE
  if (size < MIN_CURSOR_SIZE) size = MIN_CURSOR_SIZE;
  // For bigger cursor sizes, using DOM element to follow the cursor
  // https://stackoverflow.com/questions/6648279/cursor-256x256-px-size
  if (size > CURSOR_SWITCH_THRESHOLD) size = 1;
  return `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='${size}' height='${size}'><circle cx='${size / 2}' cy='${size / 2}' r='${size / 2}' fill='currentColor' /></svg>") ${size / 2} ${size / 2}, crosshair`;
}